/**
 * Source de vérité unique pour le calcul des coûts salariaux BTP
 *
 * FORMULE : coût = taux_net × coefficient_charges × heures
 *
 * - taux_net : salaire net horaire du salarié
 * - coefficient_charges : multiplicateur net → coût employeur (défaut 1.85)
 *   Inclut : charges salariales + patronales + CIBTP + ProBTP + AT/MP
 * - heures_par_jour : défaut 8h (40h/semaine convention BTP)
 */

/** Coefficient charges BTP par défaut */
export const COEFFICIENT_CHARGES_DEFAUT = 1.85;

/** Heures par jour BTP par défaut (40h/semaine) */
export const HEURES_PAR_JOUR_DEFAUT = 8;

/**
 * Coût horaire employeur = taux_net × coefficient
 */
export function calculerCoutHoraireEmployeur(
  tauxNet: number,
  coefficientCharges: number
): number {
  return tauxNet * coefficientCharges;
}

/**
 * Coût journalier = taux_net × coefficient × heures
 */
export function calculerCoutJournalier(
  tauxNet: number,
  coefficientCharges: number,
  heuresParJour: number
): number {
  return tauxNet * coefficientCharges * heuresParJour;
}

/**
 * Coût d'une affectation = coût journalier × jours
 */
export function calculerCoutAffectation(
  tauxNet: number,
  coefficientCharges: number,
  heuresParJour: number,
  joursTravailles: number
): number {
  return calculerCoutJournalier(tauxNet, coefficientCharges, heuresParJour) * joursTravailles;
}

/**
 * Coût pour un nombre d'heures donné (demi-journées, heures sup, etc.)
 */
export function calculerCoutHeures(
  tauxNet: number,
  coefficientCharges: number,
  heures: number
): number {
  return tauxNet * coefficientCharges * heures;
}
